import { Link } from "react-router-dom";
import { useRelacionesCatalogo } from "../hooks/useRelacionesCatalogo";

/**
 * Muestra un aviso cuando hay relaciones del catálogo sin configurar.
 * Solo aparece si hay faltantes; no renderiza nada si todo está ok.
 *
 * Props:
 *   campos  — array de claves a revisar (default: las 3 principales)
 *             ej: ["rel_cuenta_bancos"] para mostrar solo si bancos no está configurado
 */
export default function RelacionesAlert({ campos }) {
  const { faltantes, loading } = useRelacionesCatalogo();
  if (loading) return null;

  const filtrados = campos
    ? faltantes.filter(f => campos.includes(f.campo))
    : faltantes;

  if (filtrados.length === 0) return null;

  return (
    <div style={{
      display: "flex", alignItems: "flex-start", gap: 12,
      background: "rgba(251,191,36,0.08)",
      border: "1px solid rgba(251,191,36,0.3)",
      borderRadius: 10, padding: "12px 16px", marginBottom: 20,
    }}>
      <i className="fa-solid fa-triangle-exclamation"
        style={{ color: "#fbbf24", fontSize: "1rem", marginTop: 2, flexShrink: 0 }}/>
      <div>
        <p style={{ margin: "0 0 4px", color: "#fbbf24", fontWeight: 700, fontSize: "0.84rem" }}>
          Relaciones del catálogo sin configurar
        </p>
        <p style={{ margin: "0 0 6px", color: "#94a3b8", fontSize: "0.78rem" }}>
          Las siguientes relaciones no tienen una cuenta padre asignada.
          No podrás crear registros que dependan de ellas hasta configurarlas:
        </p>
        <ul style={{ margin: "0 0 8px", paddingLeft: 18, color: "#94a3b8", fontSize: "0.78rem" }}>
          {filtrados.map(f => <li key={f.campo}>{f.label}</li>)}
        </ul>
        <Link to="/settings"
          style={{ color: "#f97316", fontSize: "0.78rem", fontWeight: 600, textDecoration: "none" }}>
          <i className="fa-solid fa-arrow-right" style={{ marginRight: 5 }}/>
          Ir a Configuraciones → Relaciones Contables
        </Link>
      </div>
    </div>
  );
}
